// src/components/dashboard/OrdersByMonthChart.tsx
import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import api from '../../services/api';
import { ChartContainer, ChartTitle } from './dashboard.styled';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

interface OrdersByMonthData {
    month: string;
    total: number;
}

const OrdersByMonthChart: React.FC = () => {
    const [data, setData] = useState<OrdersByMonthData[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await api.get('/dashboard/orders-by-month');

            const monthMap = response.data.reduce((acc: Record<string, number>, item: any) => {
                const monthKey = String(item.month).padStart(2, '0');
                acc[monthKey] = parseInt(item.total);
                return acc;
            }, {});


            const formatted = months.map((monthName, index) => {
                const monthKey = String(index + 1).padStart(2, '0');
                return {
                    month: monthName,
                    total: monthMap[monthKey] || 0
                };
            });

            setData(formatted);
        };

        fetchData();
    }, []);

    const chartData = {
        labels: data.map(d => d.month),
        datasets: [
            {
                label: 'Total de Ordens',
                data: data.map(d => d.total),
                backgroundColor: '#8884d8'
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' as const },
            title: { display: false }
        },
        scales: {
            x: { beginAtZero: true },
            y: { beginAtZero: true }
        }
    };

    return (
        <ChartContainer>
            <ChartTitle>Ordens por Mês</ChartTitle>
            <Bar data={chartData} options={options} height={50} />
        </ChartContainer>
    );
};

export default OrdersByMonthChart;
